import React from 'react';
import { motion } from 'framer-motion';
import { FaUserShield, FaDatabase, FaCookie, FaShareAlt, FaLock, FaExternalLinkAlt, FaSyncAlt, FaEnvelope } from 'react-icons/fa';
const sections = [
  {
    icon: <FaDatabase />,
    title: '१. माहिती संकलन',
    content: 'आम्ही मर्यादित वैयक्तिक माहिती संकलित करू शकतो जसे: नाव, ईमेल पत्ता, फोन नंबर, संपर्क फॉर्मद्वारे सादर केलेले संदेश. ही माहिती केवळ संवाद व सेवा उद्देशांसाठी संकलित केली जाते.'
  },
  {
    icon: <FaUserShield />,
    title: '२. माहितीचा वापर',
    content: 'संकलित माहितीचा वापर खालीलसाठी केला जातो: चौकशींना उत्तर देणे, पंचायत सेवांबद्दल माहिती प्रदान करणे, संकेतस्थळ सेवा सुधारणे.'
  },
  {
    icon: <FaLock />,
    title: '३. डेटा संरक्षण',
    content: 'ग्रामपंचायत नाशेरा वापरकर्त्यांच्या डेटाला अनधिकृत प्रवेश किंवा गैरवापरापासून संरक्षण करण्यासाठी योग्य सुरक्षा उपाय करते.'
  },
  {
    icon: <FaCookie />,
    title: '४. कुकीज',
    content: 'हे संकेतस्थळ वापरकर्त्याचा अनुभव आणि संकेतस्थळाची कार्यक्षमता सुधारण्यासाठी कुकीजचा वापर करू शकते.'
  },
  {
    icon: <FaShareAlt />,
    title: '५. तृतीय पक्षाशी सामायिकरण',
    content: 'या संकेतस्थळावर संकलित वैयक्तिक माहिती कायद्याने किंवा शासकीय प्राधिकरणांनी आवश्यक केल्याशिवाय तृतीय पक्षांसोबत सामायिक केली जाणार नाही.'
  },
  {
    icon: <FaExternalLinkAlt />,
    title: '६. बाह्य संकेतस्थळे',
    content: 'आमच्या संकेतस्थळावर इतर शासकीय किंवा बाह्य संकेतस्थळांचे दुवे असू शकतात. त्यांच्या गोपनीयता पद्धतींसाठी आम्ही जबाबदार नाही.'
  },
  {
    icon: <FaSyncAlt />,
    title: '७. धोरण अद्यतन',
    content: 'हे गोपनीयता धोरण वेळोवेळी अद्यतनित केले जाऊ शकते. वापरकर्त्यांना हे पृष्ठ नियमितपणे तपासण्याचे प्रोत्साहन दिले जाते.'
  },
  {
    icon: <FaEnvelope />,
    title: '८. संपर्क करा',
    content: 'गोपनीयतेशी संबंधित कोणत्याही समस्यांसाठी संपर्क करा: ग्रामपंचायत नाशेरा, तालुका: मोखाडा | जिल्हा: पालघर, महाराष्ट्र - ४०१६०४. ईमेल: gpnasherapsmokhada@gmail.com'
  }
];

function Privacy({ language }) {
  return (
    <div style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <motion.section
        className="hero"
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <motion.h1
            className="page-hero-title"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            गोपनीयता धोरण
          </motion.h1>
          <motion.p
            className="page-hero-sub"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            ग्रामपंचायत नाशेरा — आपल्या माहितीचे संरक्षण आमची जबाबदारी
          </motion.p>
        </div>
      </motion.section>

      <section className="services-section">
        <div className="container">
          {/* Intro banner */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #138808 0%, #2e7d32 100%)',
              color: 'white',
              padding: '2rem 2.5rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginBottom: '3rem',
              boxShadow: '0 10px 30px rgba(19,136,8,0.25)'
            }}
          >
            <div style={{ fontSize: '2.5rem', marginBottom: '0.8rem' }}>
              <FaUserShield />
            </div>
            <h2 style={{ marginBottom: '0.8rem', fontSize: '1.6rem', fontWeight: 700 }}>
              आपली गोपनीयता आमच्यासाठी महत्त्वाची आहे
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.7', opacity: 0.92 }}>
              ग्रामपंचायत नाशेरा या संकेतस्थळाचा वापर करणाऱ्या अभ्यागतांच्या गोपनीयतेचा आदर करते.
            </p>
          </motion.div>

          {/* Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2rem'
          }}>
            {sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.07 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.13)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.5rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {section.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontWeight: '700', fontSize: '1rem', marginBottom: '0.5rem' }}>
                    {section.title}
                  </h4>
                  <p style={{ color: '#555', fontSize: '0.92rem', lineHeight: '1.7', margin: 0 }}>
                    {section.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Footer note */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #1a3a2a, #0f2027)',
              color: 'white',
              padding: '1.8rem 2rem',
              borderRadius: '12px',
              textAlign: 'center',
              marginTop: '1rem'
            }}
          >
            <FaLock style={{ fontSize: '1.8rem', marginBottom: '0.8rem', opacity: 0.8 }} />
            <p style={{ fontSize: '1rem', margin: 0, opacity: 0.9, lineHeight: 1.7 }}>
              आम्ही आपल्या वैयक्तिक माहितीचे संरक्षण करण्यासाठी उद्योग-मानक सुरक्षा उपाय राबवतो
              आणि आपली गोपनीयता सर्वकाळ राखली जाईल याची खात्री करतो.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
